import { registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideSvgIconsConfig } from '@ngneat/svg-icon';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { DynamicImportLoader } from './i18n/dynamic-import-loader';
import { ackOkIcon } from './svg/ack-ok';
import { alertCircleIcon } from './svg/alert-circle';
import { arrowLeftIcon } from './svg/arrow-left';
import { arrowRightIcon } from './svg/arrow-right';
import { bellIcon } from './svg/bell';
import { bookIcon } from './svg/book';
import { cancelIcon } from './svg/cancel';
import { checkIcon } from './svg/check';
import { checkCircleIcon } from './svg/check-circle';
import { chevronDownIcon } from './svg/chevron-down';
import { chevronLeftIcon } from './svg/chevron-left';
import { chevronUpIcon } from './svg/chevron-up';
import { clipboardIcon } from './svg/clipboard';
import { contactIcon } from './svg/contact';
import { copyIcon } from './svg/copy';
import { copyToClipboardIcon } from './svg/copy-to-clipboard';
import { downloadIcon } from './svg/download';
import { editIcon } from './svg/edit';
import { enterIcon } from './svg/enter';
import { eyeIcon } from './svg/eye';
import { faberAvatarIcon } from './svg/faber-avatar';
import { inProgressIcon } from './svg/in-progress';
import { infoIcon } from './svg/info';
import { keyIcon } from './svg/key';
import { lockIcon } from './svg/lock';
import { logOutIcon } from './svg/log-out';
import { openInNewIcon } from './svg/open-in-new';
import { openLockIcon } from './svg/open-lock';
import { plusIcon } from './svg/plus';
import { refreshIcon } from './svg/refresh';
import { sentToSapIcon } from './svg/sent-to-sap';
import { settingsIcon } from './svg/settings';
import { trashIcon } from './svg/trash';
import { uploadCertificateIcon } from './svg/upload-certificate';
import { uploadCsvIcon } from './svg/upload-csv';
import { userIcon } from './svg/user';
import { usersListIcon } from './svg/users-list';
import { validateIcon } from './svg/validate';
import { warningIcon } from './svg/warning';

export const svgIcons = [
  // ! sort these items
  ackOkIcon,
  alertCircleIcon,
  arrowLeftIcon,
  arrowRightIcon,
  bellIcon,
  bookIcon,
  cancelIcon,
  checkCircleIcon,
  checkIcon,
  chevronDownIcon,
  chevronLeftIcon,
  chevronUpIcon,
  clipboardIcon,
  contactIcon,
  copyIcon,
  copyToClipboardIcon,
  downloadIcon,
  editIcon,
  enterIcon,
  eyeIcon,
  faberAvatarIcon,
  infoIcon,
  inProgressIcon,
  keyIcon,
  lockIcon,
  logOutIcon,
  openInNewIcon,
  openLockIcon,
  plusIcon,
  refreshIcon,
  settingsIcon,
  sentToSapIcon,
  trashIcon,
  uploadCertificateIcon,
  uploadCsvIcon,
  userIcon,
  usersListIcon,
  validateIcon,
  warningIcon,
];

export type SvgName = (typeof svgIcons)[number]['name'];

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'en-EN' },
    provideHttpClient(),
    provideSvgIconsConfig({ icons: svgIcons }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: environment.defaultLang,
        loader: {
          provide: TranslateLoader,
          useClass: DynamicImportLoader,
        },
      }),
    ),
  ],
};
